import { render, staticRenderFns } from "./Brokers.vue?vue&type=template&id=0fc7d56a&scoped=true"
import script from "./Brokers.vue?vue&type=script&lang=js"
export * from "./Brokers.vue?vue&type=script&lang=js"
import style0 from "./Brokers.vue?vue&type=style&index=0&id=0fc7d56a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc7d56a",
  null
  
)

export default component.exports